/**
 * Registration Confirmation email template (HTML) — English.
 * Placeholders use {{key}} syntax.
 * Editable sections use {{emailHeadingRow}}, {{emailBodyRow}}, {{emailEventDetailsHeadingRow}}, {{emailEventDetailsSubtextRow}} (hidden when empty).
 */
export const DEFAULT_THANK_YOU_EMAIL_TEMPLATE_HTML_ENG = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml"
      xmlns:v="urn:schemas-microsoft-com:vml"
      xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="format-detection" content="telephone=no" />
    <meta name="format-detection" content="date=no" />
    <meta name="format-detection" content="address=no" />
    <meta name="format-detection" content="email=no" />
    <title>You are Successfully Registered – {{event.title}}</title>

    <!--[if gte mso 9]>
      <xml>
        <o:OfficeDocumentSettings>
          <o:AllowPNG />
          <o:PixelsPerInch>96</o:PixelsPerInch>
        </o:OfficeDocumentSettings>
      </xml>
    <![endif]-->

    <style type="text/css">
        body {
            margin: 0 !important;
            padding: 0 !important;
            -webkit-text-size-adjust: 100% !important;
            -ms-text-size-adjust: 100% !important;
            -webkit-font-smoothing: antialiased !important;
        }

        img {
            border: 0 !important;
            outline: none !important;
            display: block;
        }

        table {
            border-collapse: separate !important;
            mso-table-lspace: 0pt !important;
            mso-table-rspace: 0pt !important;
        }

        td {
            border-collapse: separate !important;
        }

        a {
            text-decoration: none;
        }

        .ReadMsgBody { width: 100%; }
        .ExternalClass { width: 100%; }
        .ExternalClass,
        .ExternalClass p,
        .ExternalClass span,
        .ExternalClass font,
        .ExternalClass td,
        .ExternalClass div {
            line-height: 100%;
        }

        a[x-apple-data-detectors] {
            color: inherit !important;
            text-decoration: none !important;
            font-size: inherit !important;
            font-family: inherit !important;
            font-weight: inherit !important;
            line-height: inherit !important;
        }

        u + #body a {
            color: inherit;
            text-decoration: none;
            font-size: inherit;
            font-family: inherit;
            font-weight: inherit;
            line-height: inherit;
        }

        @media only screen and (max-width: 600px) {
            .wrapper { width: 100% !important; }
            .container {
                width: 100% !important;
                padding-left: 20px !important;
                padding-right: 20px !important;
            }
            .mobile-padding {
                padding-left: 15px !important;
                padding-right: 15px !important;
            }
            .mobile-hide { display: none !important; }
            .mobile-text-center { text-align: center !important; }
        }
    </style>
</head>

<body id="body" style="margin: 0; padding: 0; background-color: #f5f5f8">
    <!-- Preheader text (hidden) -->
    <div style="
        display: none;
        font-size: 1px;
        color: #f5f5f8;
        line-height: 1px;
        max-height: 0px;
        max-width: 0px;
        opacity: 0;
        overflow: hidden;
      ">
        Thank you for registering for the event. We're delighted to confirm your participation.
    </div>

    <!-- Main wrapper table -->
    <table role="presentation"
           width="100%"
           border="0"
           cellspacing="0"
           cellpadding="0"
           style="background-color: #f5f5f8">
        <tr>
            <td align="center" style="padding: 40px 20px">
                <!-- 600px container -->
                <table role="presentation"
                       class="wrapper"
                       width="600"
                       border="0"
                       cellspacing="0"
                       cellpadding="0"
                       style="
              width: 600px;
              max-width: 100%;
              background-color: {{Primary_Color}};
              border-radius: 16px;
              overflow: hidden;
              box-shadow: 0px 25px 50px -12px #00000040;
            ">
                    <!-- Header with logo -->
                    <tr>
                        <td align="center"
                            style="padding: 32px 40px 24px 40px; background-color: #ffffff">
                            <table role="presentation"
                                   border="0"
                                   cellspacing="0"
                                   cellpadding="0">
                                <tr>
                                    <td align="center">
                                        <div style="display:flex;justify-content:center;align-items:center;width:130px;height:130px;border:1px solid #000000;border-radius:500px;">
                                            <img src="{{branding.logoUrl}}"
                                                 alt="{{branding.logoAlt}}"
                                                 style="display: block; width:100px; height:auto; object-fit:contain; margin:0 auto;" />
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                    {{emailBadgeRow}}

                    <!-- Rectangle image -->
                    {{HeaderImageBlock_START}}<tr>
                        <td align="center"
                            style="padding: 16px 40px 16px 40px; background-color: #ffffff">
                            <img src="{{Rectangle.Img}}" alt="" style="max-width:504px;height:100%;width:100%;border-radius:32px" />
                        </td>
                    </tr>{{HeaderImageBlock_END}}

                    {{emailHeadingRow}}

                    {{emailBodyRow}}

                    <!-- Event details section -->
                    <tr>
                        <td style="padding: 40px 40px 32px 40px">
                            <table role="presentation"
                                   width="100%"
                                   border="0"
                                   cellspacing="0"
                                   cellpadding="0"
                                   style="
                    background-color: #ffffff;
                    border-radius: 16px;
                    padding: 32px;
                  ">
                                <tr>
                                    <td style="padding: 0px">
                                        <table role="presentation"
                                               width="100%"
                                               border="0"
                                               cellspacing="0"
                                               cellpadding="0">
                                            {{emailEventDetailsHeadingRow}}
                                            {{emailEventDetailsSubtextRow}}

                                            <!-- Date row -->
                                            <tr>
                                                <td style="
                              padding-bottom: 16px;
                              vertical-align: top;
                              padding-right: 8px;
                            ">
                                                    <table role="presentation"
                                                           width="100%"
                                                           border="0"
                                                           cellspacing="0"
                                                           cellpadding="0">
                                                        <tr>
                                                            <td width="48"
                                                                style="
                                    vertical-align: top;
                                    padding-right: 12px;
                                  ">
                                                                <img src="{{Date.Icon}}"
                                                                     alt="Date"
                                                                     width="48"
                                                                     height="48"
                                                                     style="
                                      display: block;
                                      width: 48px;
                                      height: 48px;
                                    " />
                                                            </td>
                                                            <td style="vertical-align: top">
                                                                <p style="
                                      margin: 0 0 4px 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 12px;
                                      font-weight: 400;
                                      color: #637381;
                                      line-height: 16px;
                                      text-transform: uppercase;
                                      letter-spacing: 0.5px;
                                    ">
                                                                    Date
                                                                </p>
                                                                <p style="
                                      margin: 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 14px;
                                      font-weight: 500;
                                      color: #161c24;
                                      line-height: 20px;
                                    ">
                                                                    {{emailDate}}
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>

                                            <!-- Time row -->
                                            <tr>
                                                <td style="
                              padding-bottom: 16px;
                              vertical-align: top;
                            ">
                                                    <table role="presentation"
                                                           width="100%"
                                                           border="0"
                                                           cellspacing="0"
                                                           cellpadding="0">
                                                        <tr>
                                                            <td width="48"
                                                                style="
                                    vertical-align: top;
                                    padding-right: 12px;
                                  ">
                                                                <img src="{{Time.Icon}}"
                                                                     alt="Time"
                                                                     width="48"
                                                                     height="48"
                                                                     style="
                                      display: block;
                                      width: 48px;
                                      height: 48px;
                                    " />
                                                            </td>
                                                            <td style="vertical-align: top">
                                                                <p style="
                                      margin: 0 0 4px 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 12px;
                                      color: #637381;
                                      line-height: 16px;
                                      text-transform: uppercase;
                                      letter-spacing: 0.5px;
                                    ">
                                                                    Time
                                                                </p>
                                                                <p style="
                                      margin: 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 14px;
                                      font-weight: 500;
                                      color: #161c24;
                                      line-height: 20px;
                                    ">
                                                                    {{emailTime}}
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>

                                            <!-- Location row -->
                                            <!--{{Location_Block_START}}-->
                                            <tr>
                                                <td colspan="2">
                                                    <table role="presentation"
                                                           width="100%"
                                                           border="0"
                                                           cellspacing="0"
                                                           cellpadding="0">
                                                        <tr>
                                                            <td width="48"
                                                                style="
                                    vertical-align: top;
                                    padding-right: 12px;
                                  ">
                                                                <img src="{{Location.Icon}}"
                                                                     alt="Location"
                                                                     width="48"
                                                                     height="48"
                                                                     style="
                                      display: block;
                                      width: 48px;
                                      height: 48px;
                                    " />
                                                            </td>
                                                            <td style="vertical-align: top">
                                                                <p style="
                                      margin: 0 0 4px 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 12px;
                                      font-weight: 400;
                                      color: #637381;
                                      line-height: 16px;
                                      text-transform: uppercase;
                                      letter-spacing: 0.5px;
                                    ">
                                                                    Location
                                                                </p>
                                                                <p style="
                                      margin: 0;
                                      font-family:
                                        -apple-system, BlinkMacSystemFont,
                                        &quot;Segoe UI&quot;, Roboto, Helvetica,
                                        Arial, sans-serif;
                                      font-size: 14px;
                                      font-weight: 500;
                                      color: #161c24;
                                      line-height: 20px;
                                    ">
                                                                    {{emailLocation}}
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <!--{{Location_Block_END}}-->

                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                    <!-- Footer -->
                    <tr>
                        <td align="center"
                            style="padding: 32px 40px; background-color: #f9fafb">
                            <p style="
                    margin: 0 0 8px 0;
                    font-family:
                      -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;,
                      Roboto, Helvetica, Arial, sans-serif;
                    font-size: 14px;
                    font-weight: 400;
                    color: #637381;
                    line-height: 20px;
                    text-align: center;
                  ">
                                Got any questions?
                            </p>
                            <p style='
                    margin: 0 0 20px 0;
                    font-family:
                      -apple-system, BlinkMacSystemFont, "Segoe UI",
                      Roboto, Helvetica, Arial, sans-serif;
                    font-size: 14px;
                    color: {{Primary_Color}};
                    line-height: 20px;
                    text-align: center;
                  '>
                                <a href="mailto:{{branding.contactEmail}}"
                                   style="color: {{Primary_Color}}; text-decoration: none">Contact our event team</a>
                            </p>

                            <!-- Social icons -->
                            <table role="presentation"
                                   border="0"
                                   cellspacing="0"
                                   cellpadding="0"
                                   align="center">
                                <tr>
                                    <td style="padding: 0 6px">
                                        <a href="{{branding.socialLinks.facebook}}"
                                           style="display: block; text-decoration: none">
                                            <table role="presentation" border="0" cellspacing="0" cellpadding="0"
                                                 <tr style="border: 1px solid rgba(29, 29, 27, .2); display: block; padding: 5px">
                                                    <td align="center" valign="middle" style="line-height: 0">
                                                        <img src="{{Facebook.Icon}}" alt="Facebook" width="16px" height="16px"
                                                             style="display: block; width: 16px; height: 16px;" />
                                                    </td>
                                                </tr>
                                            </table>
                                        </a>
                                    </td>
                                    <td style="padding: 0 6px">
                                        <a href="{{branding.socialLinks.instagram}}"
                                           style="display: block; text-decoration: none">
                                            <table role="presentation" border="0" cellspacing="0" cellpadding="0"
                                                 <tr style="border: 1px solid rgba(29, 29, 27, .2); display: block; padding: 5px">
                                                    <td align="center" valign="middle" style="line-height: 0">
                                                        <img src="{{Instagram.Icon}}" alt="Instagram" width="16px" height="16px"
                                                             style="display: block; width: 16px; height: 16px;" />
                                                    </td>
                                                </tr>
                                            </table>
                                        </a>
                                    </td>
                                    <td style="padding: 0 6px">
                                        <a href="{{branding.socialLinks.linkedin}}"
                                           style="display: block; text-decoration: none">
                                            <table role="presentation" border="0" cellspacing="0" cellpadding="0"
                                                 <tr style="border: 1px solid rgba(29, 29, 27, .2); display: block; padding: 5px">
                                                    <td align="center" valign="middle" style="line-height: 0">
                                                        <img src="{{LinkedIn.Icon}}" alt="LinkedIn" width="16px" height="16px"
                                                             style="display: block; width: 16px; height: 16px;" />
                                                    </td>
                                                </tr>
                                            </table>
                                        </a>
                                    </td>
                                </tr>
                            </table>

                            <table role="presentation" border="0" cellspacing="0" cellpadding="0" align="center"
                                   style="margin-top: 24px; margin-bottom: 24px; width: 100%">
                                <tr>
                                    <td style="border-top: 1px solid #9a9a983d; height: 1px; line-height: 1px; font-size: 1px;">
                                        &nbsp;
                                    </td>
                                </tr>
                            </table>

                            <table role="presentation" border="0" cellspacing="0" cellpadding="0" align="center"
                                   style="margin-bottom: 16px">
                                <tr>
                                    <td align="center">
                                        <table role="presentation" border="0" cellspacing="0" cellpadding="0">
                                            <tr>
                                              
                                                <td style="vertical-align: middle; padding-right: 8px">
                                                    <img src="{{VDK.Icon}}"
                                                         alt="VDK Logo"
                                                        
                                                         style="display: block; width: 80px; height: auto" />
                                                </td>
                                        
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>

                            <p style="
                    margin: 0 0 4px 0;
                    font-family: -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, Helvetica, Arial, sans-serif;
                    font-size: 12px;
                    font-weight: 400;
                    color: #637381;
                    line-height: 18px;
                    text-align: center;
                  ">
                                © 2026 VDK Groep. All rights reserved.
                            </p>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>
</html>`;
export const DEFAULT_NEW_EVENT_THANK_YOU_EMAIL_BODY = '{"emailHeading":"<p>You are<br />Successfully<br />Registered</p>","emailBody":"<p>We\'re glad you signed up. Your registration is complete, and we can\'t wait to welcome you to an event that brings together great moments, good company, and a well-planned experience.</p>","emailEventDetailsHeading":"Event details","emailEventDetailsSubtext":"A carefully curated event awaits","emailBadge":"Welcome","emailButtonText":"View Details"}';
/**
 * Default placeholder values for registration confirmation email preview.
 */
export const DEFAULT_EMAIL_PLACEHOLDER_VALUES_THANK_YOU_ENG = {
    // Editor-driven keys
    emailBadge: 'Welcome',
    emailHeading: 'You are<br />Successfully<br />Registered',
    emailBody: "<p>We're glad you signed up. Your registration is complete, and we can't wait to welcome you to an event that brings together great moments, good company, and a well-planned experience.</p>",
    emailEventDetailsHeading: 'Event details',
    emailEventDetailsSubtext: 'A carefully curated event awaits',
    // Event
    'event.title': 'Event name',
    'event.description': 'Event description',
    emailDate: '{{sys:eventDate}}',
    emailTime: '{{sys:eventStartTime}} - {{sys:eventEndTime}}',
    emailLocation: '{{sys:eventLocation}}',
    // Legacy event.* keys kept for backward compatibility
    'event.date': '15 March 2026',
    'event.timeStart': '10:00',
    'event.timeEnd': '18:00',
    'event.location.address': 'Sample Street 123',
    'event.location.city': 'Amsterdam',
    // Branding / colors
    Primary_Color: '#e94e1b',
    Contrast_Color: '#161c24',
    'branding.logoUrl': '{{branding.logoUrl}}',
    'branding.logoAlt': 'Logo',
    'branding.contactEmail': 'events@example.com',
    'branding.socialLinks.facebook': '#',
    'branding.socialLinks.instagram': '#',
    'branding.socialLinks.linkedin': '#',
    // Images & icons
    'Rectangle.Img': '/assets/images/rectangle.png',
    HeaderImageBlock_START: '',
    HeaderImageBlock_END: '',
    'Date.Icon': '',
    'Time.Icon': '',
    'Location.Icon': '',
    'Arrow.Icon': '',
    'Facebook.Icon': '/assets/images/social-media-icons/facebook-icon.png',
    'Instagram.Icon': '/assets/images/social-media-icons/instagram-icon.png',
    'LinkedIn.Icon': '/assets/images/social-media-icons/linkedin-icon.png',
    'VDK.Icon': '/assets/images/vdkLogo-eng.svg'
};
